import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "A Sorted Table",
description: "Build a custom Svelte component to sort and render schedule time slots in a table before display. Uses PartListReplacerBox, RenderComponent, and AST.change for reactive model updates.",
tags: [ "Freon", "Svelte", "external components", "PartListReplacerBox", "Schedule", "Schedule.svelte", "RenderComponent", "AST.change", "MobX", "projections", "CourseSchedule", "Table"] ,
modifiedTime: "2025-11-07T18:23:38.828Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};